import {InputProvider} from 'components/common/CartItemBuilder/providers/InputProvider'
import LocalisedDate from 'components/common/LocalisedDate'

export const MinimizedCalendar = () => {
  const date = InputProvider.useDate('optional')

  return (
    <div className="text-end">
      <LocalisedDate date={date} />
    </div>
  )
}
